// extracted by mini-css-extract-plugin
export default {"container":"Uv-z","title":"Vv-z","linkContainer":"Wv-z","viewItemLink":"Xv-z"};